import '../../../ProductCard/ProductCard.scss';
import './Wrapper.scss';

import classnames from 'classnames';
import React, { useContext } from 'react';

import { useTheme } from '../../../../hooks/useTheme';
import TRANSLATIONS from '../../../../translations/translations@default.json';
import { Context } from '../../store/store';
import Wrapper from './Wrapper';
import EnhancedWrapper from '../../ProductCardListView/ListViewWrapper/Wrapper';

const AoLovesMobileWrapper = ({ product, index }) => {
	const [state] = useContext(Context);
	const { loaded } = state;

	const theme = useTheme('aoLoves');

	const ProductWrapper = product.ShouldShowEnhancedCard
		? EnhancedWrapper
		: Wrapper;

	return (
		<li
			id={product.Code}
			className={classnames(
				'relative flex flex-col h-full w-full  pb-1  xs:pb-2  sm:pb-4 m-2 sm:mx-0 mobileCard__wrapper overflow-hidden rounded',
				theme.background,
				{
					'bg-gray-20': !loaded,
					'px-1 xs:px-2 sm:px-4': !product.ShouldShowEnhancedCard,
				}
			)}
			style={{
				WebkitTransform: 'translateZ(0)',
				backgroundImage: theme.mobileBackground,
				backgroundSize: 'cover',
			}}>
			<div
				className={classnames('flex', {
					'pl-4 items-center': product.ShouldShowEnhancedCard,
				})}>
				<div
					className={classnames(
						'ico ico-ao-loves text-white py-3 text-xl mr-2',
						{
							'mt-px': product.ShouldShowEnhancedCard,
						}
					)}></div>
				<div
					className={classnames('text-title-lg py-3', {
						[`${theme.text}`]: loaded,
						'text-gray-20': !loaded,
					})}>
					AO Loves
				</div>
			</div>

			<ProductWrapper
				{...{
					product,
					index,
					isFeatured: true,
					isEnhancedCardLayout: product.ShouldShowEnhancedCard,
				}}
			/>
		</li>
	);
};

export default AoLovesMobileWrapper;
